if (!customElements.get("category-quick-links")) {
  class CategoryQuickLinks extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
      };
    }

    connectedCallback() {
      this.slider = this.querySelector(this.selectors.swiper);
      this.options = this.slider.getAttribute("data-options");

      if (!this.slider) {
        return null;
      }
      this.initSlider();
      this.addListeners();
    }

    initSlider() {
      let inlineOptions = this.slider.dataset.options;

      if (inlineOptions) {
        inlineOptions = JSON.parse(inlineOptions);
        if (inlineOptions.mobileSpaceBetween) {
          let mobileSpaceBetween = {
            breakpoints: {
              750: {
                spaceBetween: inlineOptions.mobileSpaceBetween,
              },
            },
          };
          Object.assign(inlineOptions, mobileSpaceBetween);
        }
      }

      this.swiperParams = {
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        injectStyles: [
          ":host .swiper { padding-bottom: 30px; } :host .swiper-button-next, :host .swiper-button-prev { margin-top: -40px; } :host .swiper-button-disabled { display: none }",
        ],
        scrollbar: {
          draggable: true,
          hide: false,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        on: {
          init() {
            this.hostEl.classList.add("swiper-initialized");
          },
        },
        ...inlineOptions,
      };

      Object.assign(this.slider, this.swiperParams);

      this.slider.initialize();
    }

    addListeners() {
      document.addEventListener("shopify:section:reorder", () =>
        this.initSlider()
      );
      document.addEventListener("shopify:section:load", () =>
        this.initSlider()
      );
      document.addEventListener("shopify:section:select", () =>
        this.initSlider()
      );
      document.addEventListener("shopify:section:deselect", () =>
        this.initSlider()
      );
    }
  }

  customElements.define("category-quick-links", CategoryQuickLinks);
}
